import { SupplierReviewEntry } from '~/types/SupplierReview';

export function averageReviewScore(item: SupplierReviewEntry): number {
    let sum: number = 0;
    let scoreCount: number = 0;
    if (item.fields) {
        if (item.fields.scoreCommitment) {
            sum = sum + item.fields.scoreCommitment;
            scoreCount++;
        }
        if (item.fields.scoreInformationCommunication) {
            sum = sum + item.fields.scoreInformationCommunication;
            scoreCount++;
        }
        if (item.fields.scoreResponseTimeQuestions) {
            sum = sum + item.fields.scoreResponseTimeQuestions;
            scoreCount++;
        }
        // Same value as scoreResponseTimeQuestions, so ignore
        // if (item.fields.scoreResponseTimeQuotationRequest) {
        //     sum = sum + item.fields.scoreResponseTimeQuotationRequest;
        //     scoreCount++;
        // }
        if (item.fields.scoreWork) {
            sum = sum + item.fields.scoreWork;
            scoreCount++;
        }
        return sum / scoreCount;
    }
    return 0;
}

export function averageOfAllReviews(reviews: SupplierReviewEntry[]): number {
    if (reviews.length > 0) {
        let total = 0;
        const allReviews = reviews.map((review): number => {
            const reviewAverage = averageReviewScore(review);
            total += reviewAverage;
            return reviewAverage;
        });
        return total / allReviews.length;
    }
    return 0;
}
